import styles from "../styles/SideMenu.module.css";
import { motion } from "framer-motion";
import React from "react";

const SideMenuButton = ({
  title,
  icon: Icon,
  onClick,
  selected,
  collapsed = false,
}) => {
  return (
    <motion.div
      onClick={onClick}
      whileHover={
        selected
          ? {}
          : {
              backgroundColor: "rgba(255,255,255,0.08)",
              color: "rgba(255,255,255,0.9)",
            }
      }
      className={`${styles.sidemenubutton}${selected ? " " + styles.selected : ""}${collapsed ? " " + styles.collapsed : ""}`}
      style={collapsed ? { justifyContent: "center", padding: "10px 0" } : {}}
      title={collapsed ? title : undefined}
    >
      <div className={styles.iconWrapper}>{Icon && <Icon size={20} />}</div>
      {!collapsed && <div className={styles.titleText}>{title}</div>}
    </motion.div>
  );
};

export default SideMenuButton;
